import { FC } from 'react';
import { DxButton, DxContainer, DxListItem } from '@dvag/design-system-react';
import { checkIcon } from 'utils/util';

type FavoriteItemProps = {
  label: string;
  onClick: () => void;
  readMode: boolean;
};

export const FavoritesItem: FC<FavoriteItemProps> = ({ label, onClick, readMode }) => (
  <DxListItem
    className="favorites-selection-list-item"
    label={label}
    id={`${label}-list-item`}
    onClick={onClick}
    data-testid={`${label}-list-item`}
    type={readMode ? 'selectable' : 'default'}
  >
    <DxContainer
      slot="content"
      className={
        readMode ? 'favorite-page-item-container-read' : 'favorites-selection-item-icon-container'
      }
    >
      <DxButton
        id={`${label}-list-button`}
        type="text"
        icon={checkIcon('stern-01')}
        color="default"
      />
    </DxContainer>
  </DxListItem>
);
